// libs
import * as React from 'react'

// interfaces / constants

// classes / components
import Notification, { clsText, NotificationProps } from 'src/components/notifications/notification'

// helpers
import { textResources } from 'src/lang/de'
import DateFormatter from 'src/utils/date_formatter/date_formatter'

// images
import * as overlayInactive from 'src/components/notifications/badges/following@2x.png'
import * as overlayActive from 'src/components/notifications/badges/following_active@2x.png'

const labels = textResources.notification

export type FollowNotificationProps = {
  createdAt: string;
} & Pick<NotificationProps, 'avatarImage' | 'initiatorName' | 'isRead' | 'onClick'>

const FollowNotification: React.FC<FollowNotificationProps> = ({
  avatarImage,
  createdAt,
  initiatorName,
  isRead,
  onClick
}) => {
  return (
    <Notification
      avatarImage={avatarImage}
      badgeImageNotRead={overlayActive}
      badgeImageRead={overlayInactive}
      footer={DateFormatter.asTimeAgo(createdAt)}
      initiatorName={initiatorName}
      isRead={isRead}
      onClick={onClick}
    >
      {/* needs empty space between initiatorName and this text */}
      <span className={clsText}>{` ${labels.newFollower}` }</span>
    </Notification>
  )
}

export default FollowNotification
